import { Button } from 'shared/theme/elements';
import { DirtyPill, DrawerActs, DrawerEyebrow, DrawerHeadWrap, DrawerTitleText, DrawerX } from '../ProgramSetup.styled';

interface Props {
  eyebrow: string;
  title: string;
  dirty: boolean;
  saveLabel: string;
  saving?: boolean;
  onCancel: () => void;
  onSave: () => void;
  onClose: () => void;
}

export const DrawerHead = ({ eyebrow, title, dirty, saveLabel, saving, onCancel, onSave, onClose }: Props) => (
  <DrawerHeadWrap>
    <div style={{ minWidth: 0 }}>
      <DrawerEyebrow>{eyebrow}</DrawerEyebrow>
      <DrawerTitleText>{title}</DrawerTitleText>
    </div>
    <DrawerActs>
      <DirtyPill $on={dirty}>Unsaved changes</DirtyPill>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onSave} loading={saving}>
        {saveLabel}
      </Button>
      <DrawerX type="button" onClick={onClose} aria-label="Close">
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.3"
          strokeLinecap="round"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </DrawerX>
    </DrawerActs>
  </DrawerHeadWrap>
);
